<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useNotificationsStore } from '@/store/notifications'
import { notificationError } from '@/app/core/util/notificationUtils'
import { useI18n } from 'vue-i18n'
import TableTransfer from '../components/TableTransfer.vue'
import dayjs from 'dayjs'

import {
  getTransferRequestId,
  getPayrollInfo,
  getInfoEmployeeById,
  getFieldsTransfer,
  sendRowsTransfer,
  closeTransferRequest
} from '@/app/core/services/transfer-requests'
import { HttpService } from '@/app/core/services/http.service'
import {
  DCard,
  DBtn,
  EyeIcon,
  RefreshCw05Icon,
  Send01Icon,
  DModal,
  DLoading 
} from 'front-library'

/* router, notifications */
const router = useRouter()
const route = useRoute()
const notifications = useNotificationsStore()
const { t } = useI18n()
const http = new HttpService()


/* Datos Listas */
const payrollOrigin = ref<any>({})
const payrollDestination = ref<any>({})
const employeeInfo = ref<any>({})

/* Datos componente DLoading */
const loading = ref(false)
const messageLoading = ref('')
const vacationBalances = ref(<any>[])
const vacationRequests = ref(<any>[])
const licenseRequests = ref(<any>[])
const incidents = ref(<any>[])
const recurringIncidents = ref(<any>[])
const loans = ref(<any>[])
const closedPayrolls = ref(<any>[])

const showVacationBalances = ref(false)
const showVacationRequests = ref(false)
const showLicenseRequests = ref(false)
const showRecurringIncidents = ref(false)
const showLoans = ref(false)
const showClosedPayrolls = ref(false)


/* Datos componente table */
const columnsVacationBalances = ref([
  { key: 'send', title: t('transfer.send') },
  { key: 'yearCaused', title: t('transfer.vacationBalances.yearCaused') },
  { key: 'normalTotalDays', title: t('transfer.vacationBalances.normalTotalDays') },
  { key: 'normalPendingDays', title: t('transfer.vacationBalances.normalPendingDays') },
  { key: 'lastDateCaused', title: t('transfer.vacationBalances.lastDateCaused') },
  { key: 'isClosed', title: t('transfer.vacationBalances.isClosed') },
  { key: 'message', title: t('transfer.message') },
  { key: 'migrated', title: t('transfer.migrate')}
  
])
const columnsVacationRequests = ref([
  { key: 'send', title: t('transfer.send') },
  { key: 'normalDaysToEnjoy', title: t('transfer.vacationRequests.normalDaysToEnjoy') },
  { key: 'startDateToEnjoy', title: t('transfer.vacationRequests.startDateToEnjoy') },
  { key: 'endDateToEnjoy', title: t('transfer.vacationRequests.endDateToEnjoy') },
  { key: 'comments', title: t('transfer.vacationRequests.comments') },
  { key: 'status', title: t('transfer.vacationRequests.status') },
  { key: 'message', title: t('transfer.message') },
  { key: 'migrated', title: t('transfer.migrate') }
  
])
const columnsLicenseRequests = ref([
  { key: 'send', title: t('transfer.send') },
  { key: 'entityName', title: t('transfer.licenseRequests.entityName') },
  { key: 'startDate', title: t('transfer.licenseRequests.startDate') },
  { key: 'endDate', title: t('transfer.licenseRequests.endDate') },
  { key: 'observation', title: t('transfer.licenseRequests.observation') },
  { key: 'status', title: t('transfer.licenseRequests.status') },
  { key: 'message', title: t('transfer.message') },
  { key: 'migrated', title: t('transfer.migrate') }
  
])
const columnsRecurringIncidents = ref([
  { key: 'send', title: t('transfer.send') },
  { key: 'masterConceptCode', title: t('transfer.recurringIncidents.masterConceptCode') },
  { key: 'conceptName', title: t('transfer.recurringIncidents.conceptName') },
  { key: 'startDate', title: t('transfer.recurringIncidents.startDate') },
  { key: 'endDate', title: t('transfer.recurringIncidents.endDate') },
  { key: 'onePeriod', title: t('transfer.recurringIncidents.onePeriod') },
  { key: 'twoPeriod', title: t('transfer.recurringIncidents.twoPeriod') },
  { key: 'threePeriod', title: t('transfer.recurringIncidents.threePeriod') },
  { key: 'fourPeriod', title: t('transfer.recurringIncidents.fourPeriod') },
  { key: 'lastPeriod', title: t('transfer.recurringIncidents.lastPeriod') },
  { key: 'message', title: t('transfer.message') },
  { key: 'migrated', title: t('transfer.migrate') }
  
])
const columnsLoans = ref([
  { key: 'send', title: t('transfer.send') },
  { key: 'masterConceptCode', title: t('transfer.recurringIncidents.masterConceptCode') },
  { key: 'conceptName', title: t('transfer.loans.conceptName') },
  { key: 'type', title: t('transfer.loans.type') },
  { key: 'startDate', title: t('transfer.loans.startDate') },
  { key: 'endDate', title: t('transfer.loans.endDate') },
  { key: 'amount', title: t('transfer.loans.amount') },
  { key: 'balance', title: t('transfer.loans.balance') },
  { key: 'isLoanPaid', title: t('transfer.loans.isLoanPaid') },
  { key: 'onePeriod', title: t('transfer.loans.onePeriod') },
  { key: 'twoPeriod', title: t('transfer.loans.twoPeriod') },
  { key: 'threePeriod', title: t('transfer.loans.threePeriod') },
  { key: 'fourPeriod', title: t('transfer.loans.fourPeriod') },
  { key: 'lastPeriod', title: t('transfer.loans.lastPeriod') },
  { key: 'message', title: t('transfer.message') },
  { key: 'migrated', title: t('transfer.migrate') }
])
const columnsClosedPayrolls = ref([
  { key: 'send', title: t('transfer.send') },
  { key: 'process', title: t('transfer.closedPayrolls.process') },
  { key: 'startDate', title: t('transfer.closedPayrolls.startDate') },
  { key: 'endDate', title: t('transfer.closedPayrolls.endDate') },
  { key: 'closedBy', title: t('transfer.closedPayrolls.closedBy') },
  { key: 'closedDate', title: t('transfer.closedPayrolls.closedDate') },
  { key: 'message', title: t('transfer.message') },
  { key: 'migrated', title: t('transfer.migrate') }
])
const transferInfo = ref<any>({})
const deleteFromOrigin = ref(false)
const showCloseModal = ref(false)

/* Propiedades Computadas */
const isButtonsDisabled = computed(() => {
  return transferInfo.value.statusProcess !== 'PENDING'
})

const formatDate = computed(() => {
  return (date: any) => {
    if (!date) return '';
    const d = dayjs.utc(date);
    return d.isValid() ? d.format('DD/MM/YYYY') : '';
  }
})

/* Funciones */
const getRegisters = async (table: string) => {
  loading.value = true
  messageLoading.value = t('transfer.getView.loading')
  
  switch (table) {
    case 'vacation_balances': vacationBalances.value = []
      break
    case 'vacation_requests': vacationRequests.value = []
      break
    case 'license_requests': licenseRequests.value = []
      break
    case 'incidents': incidents.value = []
      break
    case 'recurring_incidents': recurringIncidents.value = []
      break
    case 'loans': loans.value = []
      break
    case 'closed_payrolls': closedPayrolls.value = []
      break
  }

  try {
    const response = await getFieldsTransfer(route.params.id as string, table)
    response.forEach((item: any) => {
      item.send = false
    })
    
    switch (table) {
      case 'vacation_balances':
        vacationBalances.value = response
        break
      case 'vacation_requests':
        console.log('vacation_requests', response)
        vacationRequests.value = response
        break
      case 'license_requests':
        licenseRequests.value = response
        break
      case 'incidents':
        incidents.value = response
        break
      case 'recurring_incidents':
        recurringIncidents.value = response
        break
      case 'loans':
        loans.value = response
        break
      case 'closed_payrolls':
        closedPayrolls.value = response
        break
    }
    loading.value = false
    return response
  } catch (error: any) {
    loading.value = false
    notificationError(error, 'transfer', t, notifications, loading)
  }
}

const sendRegisters = async (table: string) => {
  loading.value = true
  messageLoading.value = t('transfer.getView.sending')
  try {
    let selectedRows = []
    switch (table) {
      case 'vacation_balances':
        selectedRows = vacationBalances.value.filter((row: any) => row.send)
        break
      case 'vacation_requests':
        selectedRows = vacationRequests.value.filter((row: any) => row.send)
        break
      case 'license_requests':
        selectedRows = licenseRequests.value.filter((row: any) => row.send)
        break
      case 'incidents':
        selectedRows = incidents.value.filter((row: any) => row.send)
        break
      case 'recurring_incidents':
        selectedRows = recurringIncidents.value.filter((row: any) => row.send)
        break
      case 'loans':
        selectedRows = loans.value.filter((row: any) => row.send)
        break
      case 'closed_payrolls':
        selectedRows = closedPayrolls.value.filter((row: any) => row.send)
        break
    }
    await sendRowsTransfer(route.params.id as string, table, selectedRows)
    if (selectedRows.length === 0) {
      notifications.addNotification({
        title: t('notification.warning'),
        text: t('transfer.getView.noSelectedRows'),
        type: 'warning',
        time: 5000
      })
      loading.value = false
      return
    }
    loading.value = false
    getRegisters(table)
  } catch (error: any) {
    notificationError(error, 'transfer', t, notifications, loading)
  }
}



const closeTransfer = async () => {
  loading.value = true
  messageLoading.value = t('transfer.getView.closing')
  try {
    const data = {
      id: route.params.id,
      deleteEmployee: deleteFromOrigin.value
    }

    await closeTransferRequest(data)
    
    notifications.addNotification({
      title: t('notification.success'),
      text: t('transfer.close.notification'),
      type: 'success',
      time: 5000
    })
    showCloseModal.value = false
    back()
  } catch (error: any) {
    notificationError(error, 'transfer', t, notifications, loading)
  } finally {
    loading.value = false
  }
}

const back = () => {
  void router.push({ name: 'ListTransferRequests' })
}

onMounted(async () => {
  try {
    transferInfo.value = await getTransferRequestId(route.params.id as string)
    const [promiseOrigin, promiseDestination, promiseEmployee] = await Promise.all([
      getPayrollInfo(transferInfo.value.payrollOriginId),
      getPayrollInfo(transferInfo.value.payrollDestinationId),
      getInfoEmployeeById(transferInfo.value.employee.id)
    ])
    payrollOrigin.value = promiseOrigin
    payrollDestination.value = promiseDestination
    employeeInfo.value = promiseEmployee
    if (transferInfo.value === undefined) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('transfer.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    }
  } catch (error: any) {
    notificationError(error, 'transfer', t, notifications, loading)
  }
})
</script>
<template>
  <div class="h-full px-5">
    <DLoading v-show="loading" :message="messageLoading" />
    <DModal :open="showCloseModal" :isFooter="false" :size="'w-1/4 md:w-2/5 lg:w-1/2 xl:w-1/3 2xl:w-1/3'">
      <template v-slot:form>
        <div class="flex flex-col items-center gap-6">
          <section class="px-5 text-center text-gray-400 text-sm">
            <h1 class="text-black text-xl" v-html="t('transfer.close.title')" />
            <p class="mt-3 text-gray-600">
              {{ t('transfer.close.confirmation') }}
            </p>
            <div class="mt-4 flex items-center justify-center gap-2">
              <input type="checkbox" id="deleteFromOrigin" v-model="deleteFromOrigin"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" />
              <label for="deleteFromOrigin" class="text-sm text-gray-700">
                {{ t('transfer.close.deleteFromOrigin') }}
              </label>
            </div>
          </section>
          <section class="flex gap-3">
            <DBtn color="secondary" class="mr-3"
              @click="showCloseModal = false; deleteFromOrigin = false"
              v-html="t('form.button.cancel')" />
            <DBtn @click="closeTransfer()" v-html="t('transfer.close.save')" />
          </section>
        </div>
      </template>
    </DModal>

    <div class="bg-gray-50 pb-10">
      <div class="leading-4 pt-responsive">
        <p class="text-3xl font-semibold text-shadow text-blue-900" v-html="t('transfer.getView.title')" />
      </div>
    </div>
    <form class="scroll overflow-auto" style="height: calc(100% - 12rem)">
      <DCard>
        <div class="grid grid-cols-2 gap-4">
          <div class="h-[300px] bg-gray-100 border border-gray-250 rounded">
            <h1 class="m-4">{{ t('transfer.list.payrollOrigin') }}</h1>
            <ul class="m-8">
              <li>{{ payrollOrigin['code'] }} - {{ payrollOrigin['name'] }}</li>
              <li>{{ payrollOrigin['frequency'] }}</li>
              <li>{{ payrollOrigin['currencySymbol'] }} - {{ payrollOrigin['currency'] }}</li>
              <li>{{ t('transfer.createView.lastPayment') }} : {{ formatDate(payrollOrigin['lastPayment']) }}</li>
              <li>{{ t('transfer.createView.company') }} : {{ payrollOrigin['companyCode'] }} - {{
                payrollOrigin['companyName'] }} </li>
            </ul>

          </div>
          <div class="h-[300px] bg-gray-100 border border-gray-250 rounded">
            <h1 class="m-4">{{ t('transfer.list.payrollDestination') }}</h1>
            <div v-if="payrollDestination">
              <ul class="m-8">
                <li>{{ payrollDestination?.['code'] }} - {{ payrollDestination?.['name'] }}</li>
                <li>{{ payrollDestination?.['frequency'] }}</li>
                <li>{{ payrollDestination?.['currencySymbol'] }} - {{ payrollDestination?.['currency'] }}</li>
                <li>{{ t('transfer.createView.lastPayment') }} : {{ formatDate(payrollDestination?.['lastPayment']) }}</li>
                <li>{{ t('transfer.createView.company') }} : {{ payrollDestination?.['companyCode'] }} - {{
                  payrollDestination?.['companyName'] }} </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row-span-1 bg-gray-100 border border-gray-250 rounded p-4">
          <p class="m-4"><strong>{{ t('transfer.createView.employee') }}</strong> : {{ employeeInfo['name'] }}</p>
          <div v-if="employeeInfo">
            <div class="grid grid-cols-3 gap-4">
              <div class="col-span-1 p-4">
                <ul class="space-y-3">
                  <li><strong>{{ t('transfer.createView.position') }}</strong> : {{ employeeInfo['position'] }}</li>
                  <li><strong>{{ t('transfer.createView.turn') }}</strong> : {{ employeeInfo['turn'] }}</li>
                  <li><strong>{{ t('transfer.createView.joiningDate') }}</strong> : {{ formatDate(employeeInfo['joiningDate']) }}</li>
                </ul>
              </div>
              <div class="col-span-1 p-4">
                <ul class="space-y-3">
                  <li><strong>{{ t('transfer.createView.sucursal') }}</strong> : {{ employeeInfo['sucursal'] }}</li>
                  <li><strong>{{ t('transfer.createView.turn') }}</strong> : {{ employeeInfo['turn'] }}</li>
                </ul>
              </div>
              <div class="col-span-1 p-4">
                <ul class="space-y-3">
                  <li><strong>{{ t('transfer.createView.management') }}</strong> : {{ employeeInfo['management'] }}
                  </li>
                  <li><strong>{{ t('transfer.createView.direction') }}</strong> : {{ employeeInfo['direction'] }}</li>
                  <li><strong>{{ t('transfer.createView.department') }}</strong> : {{ employeeInfo['department'] }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row-span-1 border border-gray-250 rounded m-4">
          <!-- vacationsBalances -->
          <div class="bg-white border border-gray-250 rounded p-4 cursor-pointer">
            <h2 class="text-lg font-semibold">{{ t('transfer.getView.vacationBalances') }}</h2>
            <div class="flex justify-end">
              <RefreshCw05Icon 
                @click="getRegisters('vacation_balances');" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
              <EyeIcon @click="getRegisters('vacation_balances'); showVacationBalances = !showVacationBalances"
                class="cursor-pointer m-2" />
              <Send01Icon 
                @click="sendRegisters('vacation_balances')" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
            </div> 
            <div v-if="showVacationBalances">
              <TableTransfer :columns="columnsVacationBalances" :rows="vacationBalances" height-table="500px">
                <template #send="{ row }">
                  <input type="checkbox" v-model="row.send" style="width: 22px; height: 22px" />
                </template>
                <template #lastDateCaused="{ row }">
                  {{ formatDate(row.lastDateCaused) }}
                </template>
              </TableTransfer>
            </div>
          </div>
          <!-- vacationRequests -->
          <div class="bg-white border border-gray-250 rounded p-4 cursor-pointer">
            <h2 class="text-lg font-semibold">{{ t('transfer.getView.vacationRequests') }}</h2>
            <div class="flex justify-end">
              <RefreshCw05Icon 
                @click="getRegisters('vacation_requests');" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
              <EyeIcon @click="getRegisters('vacation_requests'); showVacationRequests = !showVacationRequests"
                class="cursor-pointer m-2" />
              <Send01Icon 
                @click="sendRegisters('vacation_requests')" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
            </div>
            <div v-if="showVacationRequests">
              <TableTransfer :columns="columnsVacationRequests" :rows="vacationRequests" height-table="500px">
                <template #send="{ row }">
                  <input type="checkbox" v-model="row.send" style="width: 22px; height: 22px" />
                </template>
                <template #startDateToEnjoy="{ row }">
                  {{ formatDate(row.startDateToEnjoy) }}
                </template>
                <template #endDateToEnjoy="{ row }">
                  {{ formatDate(row.endDateToEnjoy) }}
                </template>
              </TableTransfer>
            </div>
          </div>
          <!-- licenseRequests -->
          <div class="bg-white border border-gray-250 rounded p-4 cursor-pointer">
            <h2 class="text-lg font-semibold">{{ t('transfer.getView.licenseRequests') }}</h2>
            <div class="flex justify-end">
              <RefreshCw05Icon 
                @click="getRegisters('license_requests');" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
              <EyeIcon @click="getRegisters('license_requests'); showLicenseRequests = !showLicenseRequests"
                class="cursor-pointer m-2" />
              <Send01Icon 
                @click="sendRegisters('license_requests')" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
            </div>
            <div v-if="showLicenseRequests">
              <TableTransfer :columns="columnsLicenseRequests" :rows="licenseRequests" height-table="500px">
                <template #send="{ row }">
                  <input type="checkbox" v-model="row.send" style="width: 22px; height: 22px" />
                </template>
                <template #startDate="{ row }">
                  {{ formatDate(row.startDate) }}
                </template>
                <template #endDate="{ row }">
                  {{ formatDate(row.endDate) }}
                </template>
              </TableTransfer>
            </div>
          </div>
          <!-- recurringIncidents -->
          <div class="bg-white border border-gray-250 rounded p-4 cursor-pointer">
            <h2 class="text-lg font-semibold">{{ t('transfer.getView.recurringIncidents') }}</h2>
            <div class="flex justify-end">
              <RefreshCw05Icon 
                @click="getRegisters('recurring_incidents');" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
              <EyeIcon @click="getRegisters('recurring_incidents'); showRecurringIncidents = !showRecurringIncidents"
                class="cursor-pointer m-2" />
              <Send01Icon 
                @click="sendRegisters('recurring_incidents')" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
            </div>
            <div v-if="showRecurringIncidents">
              <TableTransfer :columns="columnsRecurringIncidents" :rows="recurringIncidents" height-table="500px">
                <template #send="{ row }">
                  <input type="checkbox" v-model="row.send" style="width: 22px; height: 22px" />
                </template>
                <template #startDate="{ row }">
                  {{ formatDate(row.startDate) }}
                </template>
                <template #endDate="{ row }">
                  {{ formatDate(row.endDate) }}
                </template>
                <template #onePeriod="{ row }">
                  <input type="checkbox" v-model="row.onePeriod" style="width: 22px; height: 22px" />
                </template>
                <template #twoPeriod="{ row }">
                  <input type="checkbox" v-model="row.twoPeriod" style="width: 22px; height: 22px" />
                </template>
                <template #threePeriod="{ row }">
                  <input type="checkbox" v-model="row.threePeriod" style="width: 22px; height: 22px" />
                </template>
                <template #fourPeriod="{ row }">
                  <input type="checkbox" v-model="row.fourPeriod" style="width: 22px; height: 22px" />
                </template>
                <template #lastPeriod="{ row }">
                  <input type="checkbox" v-model="row.lastPeriod" style="width: 22px; height: 22px" />
                </template>
              </TableTransfer>
            </div>
          </div>
          <!-- loans -->
          <div class="bg-white border border-gray-250 rounded p-4 cursor-pointer">
            <h2 class="text-lg font-semibold">{{ t('transfer.getView.loans') }}</h2>
            <div class="flex justify-end">
              <RefreshCw05Icon 
                @click="getRegisters('loans');" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
              <EyeIcon @click="getRegisters('loans'); showLoans = !showLoans" class="cursor-pointer m-2" />
              <Send01Icon 
                @click="sendRegisters('loans')" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
            </div>
            <div v-if="showLoans">
              <TableTransfer :columns="columnsLoans" :rows="loans" height-table="500px">
                <template #send="{ row }">
                  <input type="checkbox" v-model="row.send" style="width: 22px; height: 22px" />
                </template>
                <template #startDate="{ row }">
                  {{ formatDate(row.startDate) }}
                </template>
                <template #endDate="{ row }">
                  {{ formatDate(row.endDate) }}
                </template>
                <template #onePeriod="{ row }">
                  <input type="checkbox" v-model="row.onePeriod" style="width: 22px; height: 22px" />
                </template>
                <template #twoPeriod="{ row }">
                  <input type="checkbox" v-model="row.twoPeriod" style="width: 22px; height: 22px" />
                </template>
                <template #threePeriod="{ row }">
                  <input type="checkbox" v-model="row.threePeriod" style="width: 22px; height: 22px" />
                </template>
                <template #fourPeriod="{ row }">
                  <input type="checkbox" v-model="row.fourPeriod" style="width: 22px; height: 22px" />
                </template>
                <template #lastPeriod="{ row }">
                  <input type="checkbox" v-model="row.lastPeriod" style="width: 22px; height: 22px" />
                </template>
              </TableTransfer>
            </div>
          </div>
          <!-- closedPayrolls -->
          <div class="bg-white border border-gray-250 rounded p-4 cursor-pointer">
            <h2 class="text-lg font-semibold">{{ t('transfer.getView.closedPayrolls') }}</h2>
            <div class="flex justify-end">
              <RefreshCw05Icon 
                @click="getRegisters('closed_payrolls');" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
              <EyeIcon @click="getRegisters('closed_payrolls'); showClosedPayrolls = !showClosedPayrolls"
                class="cursor-pointer m-2" />
              <Send01Icon 
                @click="sendRegisters('closed_payrolls')" 
                :class="isButtonsDisabled ? 'cursor-not-allowed opacity-50 m-2' : 'cursor-pointer m-2'"
                :style="isButtonsDisabled ? 'pointer-events: none;' : ''" />
            </div>
            <div v-if="showClosedPayrolls">
              <TableTransfer :columns="columnsClosedPayrolls" :rows="closedPayrolls" height-table="500px">
                <template #send="{ row }">
                  <input type="checkbox" v-model="row.send" style="width: 22px; height: 22px" />
                </template>
                <template #startDate="{ row }">
                  {{ formatDate(row.startDate) }}
                </template>
                <template #endDate="{ row }">
                  {{ formatDate(row.endDate) }}
                </template>
                <template #closedDate="{ row }">
                  {{ formatDate(row.closedDate) }}
                </template>
              </TableTransfer>
            </div>
          </div>
        </div>
      </DCard>
    </form>
    <br>
    <div class="col-span-3 flex justify-end">
      <DBtn color="secondary" class="mr-3" @click="back" v-html="t('transfer.before')" />
      <DBtn v-if="!isButtonsDisabled" @click="showCloseModal = true" v-html="t('transfer.getView.close')" />
    </div>
  </div>
</template>
<style scoped>
.window-menu {
  min-height: 100px;
}
</style>